<div class="modal-backdrop">
    <div class="modal-box">
      <h2>Session Timeout</h2>
      <p>Your session is about to expire due to inactivity. Do you want to extend it?</p>
      <div class="modal-actions">
        <button class="logout-btn" (click)="logout()">Logout</button>
        <button class="extend-btn" (click)="extend()">Extend</button>
      </div>
    </div>
  </div>
  